module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/CHEMICAL ENGINEERING-bd4fb55c57b2ec00b11a6425ccc8ddb4.png";